module.exports = __webpack_public_path__ + "img/co.5ff55e2e.jpg";